exports.components = {
  "component---plugins-gatsby-source-dek-wp-pages-index-js": () => import("./../../../plugins/gatsby-source-dek-wp/pages/index.js" /* webpackChunkName: "component---plugins-gatsby-source-dek-wp-pages-index-js" */),
  "component---plugins-gatsby-source-dek-wp-pages-index-ria-ru-js": () => import("./../../../plugins/gatsby-source-dek-wp/pages/index-ria-ru.js" /* webpackChunkName: "component---plugins-gatsby-source-dek-wp-pages-index-ria-ru-js" */)
}

